









































































import Component from "vue-class-component";
import { Model, Emit, Ref, Prop, Vue } from "vue-property-decorator";
import { passwordRules, emailRules, required, phoneNoRules } from "@/utils/validation";
import AddressInputGroup from "@/components/inputs/AddressInputGroup.vue";
import { inject } from "inversify-props";
import { IApiService } from "@/interfaces/Services";
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

@Component({
  components: {
    AddressInputGroup
  }
})
export default class SetupPage extends Vue {
  @inject(DependencyIdentifiers.ApiService)
  private api!: IApiService;

  private isLoading = false;
  private hasErrored = false;
    
  @Ref()
  form: any;

  private formData = {
    name: "",
    email: "",
    password: "",
    phone: "",
    address: null,
    seedDummyData: false
  };

  private visibility = { password: false }
  private get formConfig() {
    return {
      email: {
        label: this.$t('account.email'),
        rules: [required, ...emailRules]
      },
      password: {
        label: this.$t('account.password'),
        value: "",
        rules: [required],
      },
      name: {
        label: this.$t('patient.fields.name'),
        rules: [required]
      },
      phone: {
        label: this.$t('patient.fields.phoneNo'),
        rules: [required, ...phoneNoRules],
        prefix: "+36"
      },
      seedDummyData: {
        label: this.$t('general.seedDummyData'),
      }
    }
  };

  async submit() {
    // @ts-ignore
    if (!this.$refs.form.validate()) {
      return;
    }
    this.isLoading = true;
    this.hasErrored = false;

    await this.api.post('/setup', { data: this.formData })
      .catch(err => {
        this.hasErrored = true;
        console.error("error", err);
      })
      .then(() => {
        this.$router.push({path:'/'})
        this.isLoading = false;
      });
  }
}
